module.exports = __webpack_public_path__ + "static/media/passatempos_1.3ca8c171.png";